import { styled } from "../../../../styles";

export const MessagesPreferencesContainer = styled("div", {
  width: "100%",

  display: "flex",
  flexDirection: "column",
  gap: "48px",

  marginTop: "6px",
  padding: "49px 48px 71px",

  fontSize: "14px",
  fontWeight: "500",
  fontFamily: "$openSans",

  color: "$gray-100",
  backgroundColor: "$white",
  borderRadius: "12px",
  border: "1px solid $gray-40",
});

export const ParentContainer = styled("div", {
  marginTop: "50px",
});

export const NotificationRow = styled("div", {
  display: "flex",
  alignItems: "center",
});

export const TextContainer = styled("div", {
  display: "flex",
  alignItems: "center",
});

export const AppointmentUrlRow = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "20px",
});

export const UrlLabel = styled("span", {
  flex: "0 0 auto",
});

export const AppointmentUrlField = styled("div", {
  flex: 1,
  maxWidth: "540px",

  "& > div": {
    width: "100%",
  },

  "& input": {
    width: "100%",
  },
});
